import { useCallback, useMemo } from 'react';
import cls from 'classnames';
import Item from './ProItem';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { list = [] } = props;
  return (
    <div className={styles['production-list']}>
      {list.map((item: any) => {
        return item.goodsList?.length ? <Item data={item} key={item.id} /> : null;
      })}
    </div>
  );
};
